// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/bg-hero.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/register-partner-banner.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.half,
.half .container > .row {
    height: 100vh;
    min-height: 600px;
}

.half > div {
    position: relative;
}

.half,
.register-page .half .container > .row {
    height: 100vh;
    min-height: 900px;
}

@media (max-width: 991.98px) {
    .half {
        min-height: auto;
    }
    .half .bg {
        height: 200px;
    }

    .register-page .half .container > .row, .half .container > .row {
        height: calc(100vh - 200px);
        min-height: auto;
    }
}

.half .contents {
    /* background: #f0f0f0; */
}

.half .contents,
.half .bg {
    width: 50%;
}

.half .bg {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.half .bg.partner-bg {
    min-height: 50vh;
    background-position: bottom;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.half .bg::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: #22222260;
}

@media (max-width: 1199.98px) {
    .half .contents,
    .half .bg {
        width: 100%;
    }
}

/* .form-control {
    border: none;
    -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    height: 54px;
    background: #fff;
}

.form-control:active,
.form-control:focus {
    outline: none;
    -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
} */

.half .bg {
    background-size: cover;
    background-position: center;
}

.half .forgot-pass {
    position: relative;
    top: 2px;
    font-size: 14px;
}

.half .login-or {
	color: #c1c1c1;
}

/* .half .or-line {
} */

.half .span-or {
    font-size: 0.935rem;
}

.half .dont-have {
    color: #3d3d3d;
    margin-top: 20px;
    font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./assets/css/auth-style.css"],"names":[],"mappings":"AAAA;;IAEI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;;IAEA;QACI,2BAA2B;QAC3B,gBAAgB;IACpB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,yDAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,yDAA2D;AAC/D;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI;;QAEI,WAAW;IACf;AACJ;;AAEA;;;;;;;;;;;;;;GAcG;;AAEH;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,eAAe;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;GACG;;AAEH;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".half,\n.half .container > .row {\n    height: 100vh;\n    min-height: 600px;\n}\n\n.half > div {\n    position: relative;\n}\n\n.half,\n.register-page .half .container > .row {\n    height: 100vh;\n    min-height: 900px;\n}\n\n@media (max-width: 991.98px) {\n    .half {\n        min-height: auto;\n    }\n    .half .bg {\n        height: 200px;\n    }\n\n    .register-page .half .container > .row, .half .container > .row {\n        height: calc(100vh - 200px);\n        min-height: auto;\n    }\n}\n\n.half .contents {\n    /* background: #f0f0f0; */\n}\n\n.half .contents,\n.half .bg {\n    width: 50%;\n}\n\n.half .bg {\n    background-image: url('../img/bg-hero.jpg');\n}\n\n.half .bg.partner-bg {\n    min-height: 50vh;\n    background-position: bottom;\n    background-image: url('../img/register-partner-banner.jpg');\n}\n\n.half .bg::after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background: #22222260;\n}\n\n@media (max-width: 1199.98px) {\n    .half .contents,\n    .half .bg {\n        width: 100%;\n    }\n}\n\n/* .form-control {\n    border: none;\n    -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);\n    border-radius: 4px;\n    height: 54px;\n    background: #fff;\n}\n\n.form-control:active,\n.form-control:focus {\n    outline: none;\n    -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);\n} */\n\n.half .bg {\n    background-size: cover;\n    background-position: center;\n}\n\n.half .forgot-pass {\n    position: relative;\n    top: 2px;\n    font-size: 14px;\n}\n\n.half .login-or {\n\tcolor: #c1c1c1;\n}\n\n/* .half .or-line {\n} */\n\n.half .span-or {\n    font-size: 0.935rem;\n}\n\n.half .dont-have {\n    color: #3d3d3d;\n    margin-top: 20px;\n    font-size: 13px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
